import { MerchantListType, MerchantListResponse } from 'lib/generated/api'
import { RestaurantType, RestaurantList } from 'types/entities'

const typeMap: Record<MerchantListType, RestaurantType> = {
  [MerchantListType.UserDefined]: 'generic',
  [MerchantListType.SystemAllMerchants]: 'allRestaurants',
  [MerchantListType.SystemPropertyManagerMerchantNetwork]: 'allRestaurants',
}
export type RestaurantListMapper = (
  response: MerchantListResponse
) => Omit<MerchantListResponse, 'results'> & { results: RestaurantList[] }
export const mapToRestaurantList: RestaurantListMapper = response => {
  const { results, ...rest } = response

  return {
    results: results.map(x => ({
      id: x.merchantListId as string,
      listName: x.name,
      listUrl: x.url,
      type: typeMap[x.type],
      referencedRestaurantsLen: x.merchants?.length || 0,
      lastModified: x.updatedAt,
    })),
    ...rest,
  }
}
